import type { InterviewDecision } from "@repo/app-types/entities/interview";
import { TooltipHoverTarget } from "@repo/ui/tooltip/hoverTarget";
import { SimpleTooltip } from "@repo/ui/tooltip/simpleTooltip";
import { TooltipTrigger } from "@repo/ui/tooltip/tooltipTrigger";
import { IconCircleCheck, IconCircleX } from "@tabler/icons-react";

export const InterviewDecisionIndicator = ({
  decision,
}: {
  decision: InterviewDecision | null;
}) => {
  if (decision === "advanced") {
    return (
      <TooltipTrigger>
        <TooltipHoverTarget shape="rounded">
          <IconCircleCheck className="h-4 w-4 shrink-0 text-green-500" />
        </TooltipHoverTarget>
        <SimpleTooltip>Candidate was advanced</SimpleTooltip>
      </TooltipTrigger>
    );
  }

  if (decision === "rejected") {
    return (
      <TooltipTrigger>
        <TooltipHoverTarget shape="rounded">
          <IconCircleX className="h-4 w-4 shrink-0 text-red-500" />
        </TooltipHoverTarget>
        <SimpleTooltip>Candidate was rejected</SimpleTooltip>
      </TooltipTrigger>
    );
  }

  return null;
};
